import { useMemo, useState } from 'react';

export const useCollapseList = <T = unknown>({
  list,
  limit,
}: {
  list: T[];
  limit: number;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => setIsExpanded((prev) => !prev);

  const transformedList = useMemo(() => {
    if (isExpanded) {
      return list;
    }
    return list?.slice(0, limit);
  }, [isExpanded, list, limit]);

  return {
    handleToggle,
    isExpanded,
    list: transformedList,
    haveHiddenItems: list.length > limit,
  };
};
